import { render, staticRenderFns } from "./ApplicantDisclosure.vue?vue&type=template&id=58849dca&scoped=true&"
import script from "./ApplicantDisclosure.vue?vue&type=script&lang=js&"
export * from "./ApplicantDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58849dca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VRadio,VRadioGroup,VTextarea})
